/*
    区域组件（查询区、表单区、表格区）
    created by: liyaoh 2019-12-04
*/
import React from 'react';
import { connect } from 'react-redux';
import { DropTarget } from 'react-dnd';
import platform from 'Pub/js/platform';
import { updateSelectArea, updateSearchBox } from "Store/ZoneSetting/action";
import { processClass } from '../LeftSideMetaTree/util';
import withTabMoreArea from './withTabMoreArea';
import { getMultiLangText } from '../../utilService';
const { NCButton, NCTabs } = platform.base;
const { NCTabPane } = NCTabs;

//渲染三大区域卡片
const renderBaseCard = (props, item, index) => {
    return props.renderCard({
        item,
        cardIndex: index,
        areaType: props.type,
    });
};

const BaseAreaItem = props => {
    //渲染区域
    const renderAreaContent = () => {
        let areaContent;
        //放入一个空的item为了拖拽时放在空的区域也能drop
        props.listWithBlank = [...props.areaItem.queryPropertyList, { blank: true, code: 'blank', areaid: props.areaItem.pk_area }];

        switch (props.areaItem.areatype) {
            case '0': //查询区
                areaContent = <BaseSearchArea type="search" {...props} />;
                break;
            case '1': //表单区
                areaContent = <BaseFormArea type="form" {...props} />;
                break;
            case '2': //表格区
                areaContent = <BaseTableArea type="table" {...props} />;
                break;
            default:
                break;
        }
        return areaContent;
    };

    return (
        <React.Fragment>
            {props.renderHeader}
            {renderAreaContent()}
        </React.Fragment>
    );
};

//渲染查询区
const BaseSearchArea = props => (
    <ul className="area-item-content" fieldid="content" style={{ display: props.isShow ? 'block' : 'none' }}>
        <div className="search-area-content">
            <div className="query-btn-area">
                <NCButton colors="primary" fieldid="search">
                    <i className="iconfont icon-sousuo" />
                </NCButton>
            </div>
            {props.listWithBlank.map((item, index) => renderBaseCard(props, item, index))}
        </div>
    </ul>
);

const formTabAreaTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            props.onTabPaneDrop(monitor);
        }
    },
};
//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', formTabAreaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
//渲染表单区
@withTabMoreArea('form')
class BaseFormArea extends React.Component {

    //得到全部页签数据
    getAllTabs = () => {
        return [this.props.areaItem].concat(this.props.areaItem.formTabs);
    }

    formTabChange = (key, area) => {
        this.props.onTabChange && this.props.onTabChange(key);
        this.props.updateSearchBox({ isHighlight: true });
        this.props.onAreaClick(undefined, area);
    };

    //渲染多页签卡片
    renderTabCard = (item, tabArea, cardIndex) => {
        let areaIndex = this.props.areaList.findIndex(item => item.pk_area === tabArea.pk_area);
        return this.props.renderCard({
            item,
            cardIndex,
            areaType: 'form',
            areaIndex,
            shouldHideGray: this.props.areaVisible[tabArea.pk_area] || false,
        });
    };

    //渲染多页签区域
    renderTabsFormArea = () => {
        const { areaItem, activeTabKey, connectDropTarget, areaHide } = this.props;
        const allTabs = this.getAllTabs();
        const getCurrentTabArea = code => allTabs.find(item => item.code === code);
        const formTabChange = key => {
            const area = getCurrentTabArea(key);
            this.props.onTabChange && this.props.onTabChange(key);
            this.props.updateSearchBox({ isHighlight: true });
            this.props.onAreaClick(undefined, area);
        };

        return connectDropTarget(
            <div
                className="table-tabs-container"
                onClick={e => e.stopPropagation()}
                data-searchcodes={JSON.stringify(allTabs.map(item => item.code))}
            >
                {/* 阻止页签点击事件向上冒泡，防止点击页签时执行父区域click事件 */}
                <NCTabs
                    activeKey={activeTabKey || areaItem.code}
                    tabBarStyle="simple"
                    extraContent={this.props.tabsExtraArea}
                    onChange={formTabChange}
                    onTabClick={formTabChange}
                    onPrevClick={e => {
                        console.log('onPrevClick', e);
                    }}
                    onNextClick={e => {
                        console.log('onNextClick', e);
                    }}
                >
                    {allTabs.map(item => {
                        let listWithBlank = [
                            ...item.queryPropertyList,
                            { blank: true, areaid: item.pk_area, code: 'blank' },
                        ];
                        const tabCards = listWithBlank.map((card, index) =>
                            this.renderTabCard(card, item, index),
                        );
                        let tabName = getMultiLangText(item, 'name', this.props.multiOptions);
                        return (
                            <NCTabPane tab={tabName} key={item.code}>
                                {this.renderFormArea(tabCards, item)}
                            </NCTabPane>
                        );
                    })}
                </NCTabs>
            </div>,
        );
    };

    renderFormArea = (cards, tab) => {
        const { areaItem, children } = this.props;
        const code = tab ? tab.code : areaItem.code;
        const cardArea =
            cards || this.props.listWithBlank.map((item, index) =>!item.blank && renderBaseCard(this.props, item, index)); //字段区域
        return (
            <ul className="area-item-content"
                fieldid="content"
                style={{ display: this.props.isShow ? 'block' : 'none' }}
            >
                <div className={`form-area-content drag-mask-content-${areaItem ? processClass(code) : ''}`}>
                    {cardArea}
                </div>
                {children && children(tab)}
            </ul>
        );
    }

    renderArea = () => {
        if (Array.isArray(this.props.areaItem.formTabs)) {
            return this.renderTabsFormArea();
        } else {
            return this.renderFormArea();
        }
    }

    render() {
        return this.renderArea();
    }
}

const tabAreaTarget = {
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            props.onTabPaneDrop(monitor);
        }
    },
};

//渲染表格区
//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', tabAreaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
@withTabMoreArea('table')
class BaseTableArea extends React.Component {

    //检查子表是否有多页签
    hasTabs = () => this.props.areaItem.tabs && this.props.areaItem.tabs.length > 0;

    //根据区域id查区域index
    getAreaIndexByPk = area => {
        if (!area) {return;}
        let areaIndex;
        this.props.areaList.map((item, index) => {
            if (item.pk_area === area.pk_area) {
                areaIndex = index;
            }
        });
        return areaIndex;
    };

    //得到全部页签数据
    getAllTabs = () => {
        return [this.props.areaItem].concat(this.props.areaItem.tabs);
    }

    //渲染表格区内容
    renderTableContent = (cards, tab) => {
        const code = tab ? tab.code : this.props.areaItem.code;
        const cardArea =
            cards || this.props.listWithBlank.map((item, index) => renderBaseCard(this.props, item, index)); //字段区域
        let isShow = tab ? tab.isShow : this.props.isShow;
        return (
            <ul
                className={`area-item-content search-area-${String(code).replace(/\.|\&|\#/g, '') || 'unknow'}`}
                fieldid="content"
                // style={{ display: this.props.isShow ? 'block' : 'none' }}
                style={{ display: isShow ? 'block' : 'none' }}
            >
                <div className={`table-area-content ${this.props.isTile ? 'tile-view' : ''} drag-mask-content-${processClass(code)}`}>{cardArea}</div>
                {this.props.children && this.props.children(tab)}
            </ul>
        );
    };

    //渲染多页签卡片
    renderTabCard = (item, tabArea, cardIndex) => {
        let areaIndex = this.getAreaIndexByPk(tabArea);
        return this.props.renderCard({
            item,
            cardIndex,
            areaType: 'table',
            areaIndex,
            shouldHideGray: this.props.areaVisible[tabArea.pk_area] || false,
        });
    };

    //渲染多页签表格区
    renderTabsTableArea = () => {
        const { areaItem, activeTabKey, connectDropTarget, areaHide } = this.props;
        const allTabs = this.getAllTabs();
        const getCurrentTabArea = code => allTabs.find(item => item.code === code);
        const tableTabChange = key => {
            const area = getCurrentTabArea(key);
            this.props.onTabChange && this.props.onTabChange(key);
            this.props.updateSearchBox({ isHighlight: true });
            this.props.onAreaClick(undefined, area);
        };

        return connectDropTarget(
            <div className="table-tabs-container" onClick={e => e.stopPropagation()} data-searchcodes={JSON.stringify(allTabs.map(item => item.code))}>
                {/* 阻止页签点击事件向上冒泡，防止点击页签时执行父区域click事件 */}
                <NCTabs
                    activeKey={activeTabKey || areaItem.code}
                    tabBarStyle="simple"
                    extraContent={this.props.tabsExtraArea}
                    onChange={tableTabChange}
                    onTabClick={tableTabChange}
                    onPrevClick={e => {
                        console.log('onPrevClick', e);
                    }}
                    onNextClick={e => {
                        console.log('onNextClick', e);
                    }}
                >
                    {allTabs.map(item => {
                        let listWithBlank = [...item.queryPropertyList, { blank: true, areaid: item.pk_area, code: 'blank' }];
                        const tabCards = listWithBlank.map((card, index) =>
                            this.renderTabCard(card, item, index),
                        );
                        let tabName = getMultiLangText(item, 'name', this.props.multiOptions);
                        return !areaHide[item.pk_area] && (
                            <NCTabPane tab={tabName} key={item.code}>
                                {this.renderTableContent(tabCards, item)}
                            </NCTabPane>
                        );
                    })}
                </NCTabs>
            </div>,
        );
    };

    //渲染表格区
    renderTableArea = () => {
        if (this.hasTabs()) {
            return this.renderTabsTableArea();
        } else {
            return this.renderTableContent();
        }
    };

    render() {
        return this.renderTableArea();
    }
}
export default connect(state => ({
    areaList: state.zoneSettingData.areaList,
    areaVisible: state.zoneSettingData.areaVisible,
    areaHide: state.zoneSettingData.areaHide,
    newAreaList: state.zoneSettingData.newAreaList,
}), {
    updateSelectArea,
    updateSearchBox,
})(BaseAreaItem);
